import { Button } from '@/components/ui/button';
import { useRegionsTable } from '@/features/teacher-student/hooks';
import { exportTeacherStudentDistrictToExcel } from '@/features/teacher-student/utils/exportTeacherStudentToExcel';
import { Download } from 'lucide-react';
import { FC } from 'react';
import { TeacherStudentHeader } from '../../header/Header';
import { headerData } from './constants';
import { TableDistrict } from './table/TableDistrict';

export const TeacherStudentDistrict: FC = () => {
  const { masterApprenticesRegionsHeader, masterApprenticesRegions, totals } =
    useRegionsTable();

  const handleExport = async () => {
    if (masterApprenticesRegions && masterApprenticesRegions.length > 0) {
      await exportTeacherStudentDistrictToExcel(masterApprenticesRegions, totals, masterApprenticesRegionsHeader?.region_name);
    }
  };

  return (
    <div className="flex flex-col gap-4 p-8">
      <div className="flex items-center justify-between">
        <TeacherStudentHeader
          title={`${masterApprenticesRegionsHeader?.region_name} viloyati bo'yicha ustoz-shogirdlar`}
          headerData={headerData}
          isResponsible={false}
        />
        {masterApprenticesRegions && masterApprenticesRegions.length > 0 && (
          <Button
            onClick={handleExport}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white"
          >
            <Download className="size-4" />
            Excel
          </Button>
        )}
      </div>
      <TableDistrict />
    </div>
  );
};
